<template>
  <div class="researchInstitute container-flfluid">
    <div class="imgDiv">
      <img :src="ResearchInstituteList.banner" />
    </div>
    <div class="titleDiv flex flex-align-items">
      <h2 class="flex align-start w1200 no-after">
        <span
          >{{ ResearchInstituteList.title }}
          <font>{{ ResearchInstituteList.titleEn }}</font>
        </span>
      </h2>
    </div>
    <div class="tabDiv">
      <div class="w1200 flex flex-justify-content">
        <div class="tab-slide centerbox tab-slide1">
          <a
            :class="
              currentIndex === 0
                ? 'tab-a centerbox border-r onthis'
                : 'tab-a centerbox'
            "
            @click="clickTab(0)"
            >行业研究</a
          >
          <a
            :class="
              currentIndex === 1
                ? 'tab-a centerbox border-r onthis'
                : 'tab-a centerbox'
            "
            @click="clickTab(1)"
            >行业学习间</a
          >
        </div>
      </div>
    </div>
    <div class="contentDiv w1200">
      <!-- 行业研究 -->
      <div class="content yjdiv" v-show="currentIndex === 0">
        <div class="list flex flex-wrap">
          <div
            class="item"
            v-for="(item, index) in visibleData"
           
            :key="index"
            @click="goStudyDetail(item)"
          >
            <a class="re-s1-a flex columnbox">
              <img :src="item.img" />
              <h4>{{ item.title }}</h4>
              <p>{{ item.text }}</p>
              <span class="flex bottom betweenbox flex-align-items">
                <div class="flex flex-align-items">
                  <img src="../../assets/images/ico-t.png" class="timeImg" />
                  <font class="flex">{{ item.time }}</font>
                </div>

                <div class="btn centerbox more-btn">详情</div>
              </span>
            </a>
          </div>
          <!-- <div v-if="showPagination" style="display: flex;justify-content: center;">
            <el-pagination  @size-change="handleStudySizeChange"
              @current-change="handleStudyCurrentChange" :current-page.sync="StudycurrentPage" :page-size="Studypagesize" background
              layout="prev, pager, next" :total="PPTList.length">
            </el-pagination>
          </div> -->
        </div>
        <div class="btnLine flex flex-justify-content">
          <a class="centerbox more-a" v-if="showMore" @click="expandContent"
            >查看更多</a
          >
        </div>
      </div>
      <!-- 行业学习间 -->
      <div class="content studyDiv" v-show="currentIndex === 1">
        <div class="tab-slide flex tab-slide2">
          <a
            :class="
              studyIndex === 0 ? 'tab-a centerbox onthis' : 'tab-a centerbox'
            "
            @click="studyTabClick(0)"
            >PPT课件</a
          >
          <a
            :class="
              studyIndex === 1 ? 'tab-a centerbox onthis' : 'tab-a centerbox'
            "
            @click="studyTabClick(1)"
            >电子书</a
          >
          <a
            :class="
              studyIndex === 2 ? 'tab-a centerbox onthis' : 'tab-a centerbox'
            "
            @click="studyTabClick(2)"
            >学术交流</a
          >
        </div>

        <div v-show="studyIndex === 0">
          <div class="ppt-ul flex flex-wrap">
            <div
              class="item"
              v-for="(item, index) in PPTList.slice((PPTcurrentPage - 1) * PPTpagesize, PPTcurrentPage * PPTpagesize)"
              :key="index"
              @click="goPPTDetail(item.title)"
            >
              <a class="centerbox columnbox">
                <img class="s1-img" :src="item.img" />
                <h4>{{ item.title }}</h4>
              </a>
            </div>
          </div>
          <div v-if="showPagination" style="display: flex;justify-content: center;">
            <el-pagination  @size-change="handlePPTSizeChange"
              @current-change="handlePPTCurrentChange" :current-page.sync="PPTcurrentPage" :page-size="PPTpagesize" background
              layout="prev, pager, next" :total="PPTList.length">
            </el-pagination>
          </div>
        </div>
        <div v-show="studyIndex === 1">
          <div class="ebook-ul flex flex-wrap betweenbox">
            <div
              class="item"
              v-for="(item, index) in EbookList.slice((BookcurrentPage - 1) * Bookpagesize, BookcurrentPage * Bookpagesize)"
              :key="index"
              @click="goeBookDetail(item.title)"
            >
              <a class="flexbox">
                <img :src="item.img" />
                <div class="text">
                  <h4>{{ item.title }}</h4>
                  <div class="flex betweenbox">
                    <span class="flexbox down-btn">下载</span>
                    {{ item.time }}
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div v-if="showPagination" style="display: flex;justify-content: center;">
            <el-pagination  @size-change="handleBookSizeChange"
              @current-change="handleBookCurrentChange" :current-page.sync="BookcurrentPage" :page-size="Bookpagesize" background
              layout="prev, pager, next" :total="EbookList.length">
            </el-pagination>
          </div>
        </div>
        <div v-show="studyIndex === 2">
          <div class="report-ul flex flex-wrap">
            <div
              class="item"
              v-for='(item, index) in list.slice((currentPage - 1) * pagesize, currentPage * pagesize)' 
              :key='index'
              @click="goExchangeDetail(item.title)"
            >
              <a class="re-s1-a flex columnbox">
                <img class="s1-img" :src="item.img" />
                <h4>{{ item.title }}</h4>
                <p></p>
                <span class="bottom flex betweenbox">
                  <font class="flexbox">{{ item.time }}</font>
                  <div class="centerbox btn">详情</div>
                </span>
              </a>
            </div>
          </div>
          <div v-if="showPagination" style="display: flex;justify-content: center;">
            <el-pagination  @size-change="handleSizeChange"
              @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pagesize" background
              layout="prev, pager, next" :total="list.length">
            </el-pagination>
          </div>
        </div>

        <div class="btnLine flex flex-justify-content">
          <a class="centerbox more-a" v-if="showMore" @click="expandContent"
            >查看更多</a
          >
        </div>
      </div>
    </div>
    <div class="grow">
      <div class="w1200 flex flex-direction-column">
        <h3 class="flex columnbox align-start">
          {{ ResearchInstituteList.title1 }}
          <font>{{ ResearchInstituteList.titleEn1 }}</font>
        </h3>
        <div class="growSelect flex">
          <div class="item" @click="goMeetAndStudy()">
            <a class="centerbox columnbox">
              <img src="../../assets/images/s2-ico1.png" />会议
              <span class="line"></span>
            </a>
          </div>
          <div class="item" @click="goStudyList()">
            <a class="centerbox columnbox">
              <img src="../../assets/images/edu.png" />教育
              <span class="line"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  metaInfo() {
    return {
      title: "创新研究院-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  data() {
    return {
      currentIndex: 0,
      studyIndex: 0,
      ResearchInstituteList: {},
      fullData: [],
      showMore: true,
      maxItems: 6, // 默认显示6条数据
      currentPage: 1,
      pagesize: 12,
      list:[],
      showPagination:false,
      PPTpagesize:12,
      PPTcurrentPage:1,
      Bookpagesize:12,
      BookcurrentPage:1,
      Studypagesize:12,
      StudycurrentPage:1,
    };
  },
  computed: {
    visibleData() {
      return this.showMore
        ? this.fullData.slice(0, this.maxItems)
        : this.fullData;
    },
  },
  created() {
    this.getList();
  },
  // 监听导航下拉回收
  watch: {},
  mounted() {},
  activated() {
    this.init();
  },
  methods: {
    init() {
      var index = this.$router.history.current.query.index;
      if (index !== undefined) {
        this.currentIndex = index;
      }
    },
    getList() {
      let data = {
        Title: "创新研究院",
        ForumTypeCode: "TYResearchInstitute",
      };
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.ResearchInstituteList = JSON.parse(
              res.data.OutputData.Content
            );

            this.fullData = this.ResearchInstituteList.industrialResearchList;
            this.list = this.ResearchInstituteList.academicExchange
            this.EbookList = this.ResearchInstituteList.Ebook;
            this.PPTList = this.ResearchInstituteList.PPTList;

          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    // PPT分页
    handlePPTSizeChange(size) {
      this.PPTpagesize = size
    },
    handlePPTCurrentChange(currentPage) {
      this.PPTcurrentPage = currentPage;
    },
    // 电子书
    handleBookSizeChange(size) {
      this.Bookpagesize = size
    },
    handleBookCurrentChange(currentPage) {
      this.BookcurrentPage = currentPage;
    },
    // study行业研究
    handleStudySizeChange(size) {
      this.Studypagesize = size
    },
    handleStudyCurrentChange(currentPage) {
      this.StudycurrentPage = currentPage;
    },
    clickTab(index) {
      this.currentIndex = index;
    },
    studyTabClick(index) {
      this.studyIndex = index;
    },
    expandContent() {
      this.showMore = false;
      this.showPagination = true;
    },
    // 行业研究详情
    goStudyDetail(item) {
      this.$router.push({
        name: "studyDetail",
        query: {
          title: item.title,
          time: item.time,
        },
      });
    },
    // ppt课件详情
    goPPTDetail(title) {
      this.$router.push({
        name: "pptDetail",
        query: {
          title: title,
        },
      });
    },
    // 电子书详情
    goeBookDetail(title) {
      this.$router.push({
        name: "ebookDetail",
        query: {
          title: title,
        },
      });
    },
    //学术交流详情
    goExchangeDetail(title) {
      this.$router.push({
        name: "exchangeDetail",
        query: {
          title: title,
        },
      });
    },
    // 会议
    goMeetAndStudy() {
      this.$router.push({ path: "/meetAndStudy" });
      // this.$router.push({ path: '/meetAndStudy', query: { tabIndex: index } })
    },
    // 教育列表
    goStudyList() {
      this.$router.push({ path: "/studyList" });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/base.less";

.researchInstitute {
  width: 100%;
  .imgDiv {
    width: 100%;
    img {
      width: 100%;
      height: auto;
    }
  }
  .titleDiv {
    width: 100%;
    border-bottom: 1px solid #e5e5e5;

    h2 {
      height: auto;
      color: #333;
      font-weight: bold;
      line-height: 1.7;
      span > font {
        display: block;
        line-height: 1.7;
      }
    }
    h2:before {
      content: "";
      background: url(../../assets/images/r-t-label.png) center center no-repeat;
      background-size: 100% auto;
    }
  }

  .tabDiv {
    width: 100%;
    .tab-slide1 {
      a {
        color: #333;
        border: 1px solid #1462b6;
        background-color: white;
        text-align: center;
      }
    }
    .tab-slide a.onthis {
      color: white;
      background-color: #1462b6;
    }
  }

  .contentDiv {
    .content {
      width: 100%;
    } //行业研究
    .yjdiv {
      .item {
        border: 1px solid #dcdcdc;
        background: #fff;
        overflow: hidden;
        transition: all 0.5s;
        h4 {
          width: 100%;
          text-align: left;
          color: #333;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
        }
        p {
          color: #767676;
          width: 100%;
          text-align: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .bottom {
          // margin: 0 auto;
          border-top: 1px solid #d2d2d2;
          font {
            color: #b2b2b2;
          }
          .btn {
            color: #0068b7;
            background: transparent;
            border: none;
            outline: 0;
            -webkit-appearance: none;
            cursor: pointer;
          }
        }
      }
    } // 行业学习间
    .studyDiv {
      .tab-slide2 {
        width: 100%;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 40px;
        a {
          font-size: 22px;
          color: #333333;
          padding-bottom: 16px;
          margin-right: 70px;
          position: relative;
        }
        a.onthis {
          background-color: white;
          color: #1462b6;
        }
        a.onthis:after {
          width: 100%;
          height: 2px;
          background: #0068b7;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          content: "";
        }
      } // PPT课件
      .ppt-ul {
        width: 100%;
        .item {
          border: 1px solid #dcdcdc;
          background: #fff;
          overflow: hidden;
          transition: all 0.5s;
          .s1-img {
            border: none;
            outline-width: 0px;
            vertical-align: top;
          }
          h4 {
            width: 100%;
            color: #333;
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: block;
          }
        }
        .item:hover {
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
          .s1-img {
            -webkit-animation: animations 5s linear infinite alternate;
            animation: animations 13s linear infinite alternate;
          }
          h4 {
            color: #197ecb;
          }
        }
        @keyframes animations {
          0% {
            transform: translate3d(0, 0, 0) scale(1);
          }
          100% {
            transform: translate3d(-5.166%, 0, 0px) scale(1.15);
          }
        }
      } // 电子书
      .ebook-ul {
        width: 100%;
        .item {
          border-bottom: 1px dashed #eee;
          img {
            flex: none;
          }
          .text {
            width: 100%;
          }
          h4 {
            display: block;
            width: 100%;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
          }
          span {
            color: #197ecb;
            cursor: pointer;
          }
          span.down-btn:before {
            content: "";
            background: url(../../assets/images/ico-down.png) center center
              no-repeat;
            background-size: cover;
          }
        }
      } // 学术交流
      .report-ul {
        width: 100%;
        .item {
          border: 1px solid #dcdcdc;
          background: #fff;
          overflow: hidden;
          transition: all 0.5s;
          h4 {
            text-align: left;
            width: 100%;
            color: #333;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: block;
          }
          p {
            color: #767676;
            width: 100%;
            text-align: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .bottom {
            margin: 0 auto;
            border-top: 1px solid #d2d2d2;
            font {
              color: #b2b2b2;
            }
            font:before {
              content: "";
              background: url(../../assets/images/ico-t.png) center center
                no-repeat;
              background-size: cover;
            }
            .btn {
              color: #0068b7;
              background: transparent;
              border: none;
              outline: 0;
              cursor: pointer;
            }
          }
        }
        .item:hover {
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
          .s1-img {
            -webkit-animation: animations 5s linear infinite alternate;
            animation: animations 13s linear infinite alternate;
          }
          h4 {
            color: #197ecb;
          }
        }
        @keyframes animations {
          0% {
            transform: translate3d(0, 0, 0) scale(1);
          }
          100% {
            transform: translate3d(-5.166%, 0, 0px) scale(1.15);
          }
        }
      }
    }
  }

  @media only screen and (min-width: 1200px) {
    padding-top: 130px;
    .titleDiv {
      height: 100px;
      h2 {
        font-size: 26px;
        span > font {
          font-size: 16px;
        }
      }
      h2:before {
        width: 4px;
        height: 48px;
        margin-right: 10px;
      }
    }
    .tabDiv {
      .tab-slide1 {
        height: 125px;
        a {
          padding: 0 20px;
          font-size: 26px;
          line-height: 54px;
          width: 220px;
        }
      }
    } //行业研究
    .yjdiv {
      .item {
        width: 31.7%;
        margin-bottom: 30px;
        margin-right: 2.45%;

        &:nth-child(3n) {
          margin-right: 0;
        }

        a > img {
          height: 258px;
          width: auto;
          max-width: none;
        }
        h4 {
          padding: 18px 10px 5px 10px;
          font-size: 18px;
        }
        p {
          font-size: 14px;
          padding: 0 10px 18px 10px;
        }
        .bottom {
          width: calc(100% - 18px);
          height: 45px;
          margin: 0 9px;
          .timeImg {
            width: 14px;
            height: 14px;
            margin-right: 10px;
          }
          font {
            font-size: 12px;
          }
          .btn {
            font-size: 16px;
            padding: 1px 6px;
          }
        }
      }
      .list {
        width: 100%;
        margin-bottom: 30px;
      }
    } // 行业学习间
    .studyDiv {
      .ppt-ul {
        .item {
          width: 31.7%;
          margin-bottom: 30px;
          margin-right: 2.45%;

          &:nth-child(3n) {
            margin-right: 0;
          }

          .s1-img {
            width: auto;
            max-width: none;
            height: 342px;
          }
          h4 {
            width: 100%;
            padding: 18px 10px 5px 10px;
            font-size: 18px;
          }
        }
      }
      .ebook-ul {
        .item {
          width: 44.8%;
          padding: 0 0 30px 0;
          margin-bottom: 30px;
          img {
            width: 100px;
            height: 100px;
            margin-right: 25px;
          }
          h4 {
            font-size: 18px;
            margin-bottom: 18px;
          }
          span {
            font-size: 16px;
          }
          span.down-btn:before {
            width: 21px;
            height: 21px;
            margin-right: 5px;
          }
        }
      }

      .report-ul {
        .item {
          width: 31.7%;
          margin-right: 2.45%;
          margin-bottom: 30px;
          &:nth-child(3n) {
            margin-right: 0;
          }
          img {
            height: 258px;
          }
          h4 {
            padding: 18px 10px 5px 10px;
            font-size: 18px;
          }
          p {
            font-size: 14px;
            padding: 0 10px 18px 10px;
          }
          .bottom {
            width:100%;
            padding: 0 10px;
            height: 45px;
            font {
              font-size: 12px;
            }
            font:before {
              width: 14px;
              height: 14px;
              margin-right: 10px;
            }
            .btn {
              font-size: 16px;
              padding: 0 6px;
            }
          }
        }
      }
    }
    .btnLine {
      .more-a {
        width: 150px;
        height: 42px;
        border-radius: 26px;
        font-size: 16px;
        margin-bottom: 60px;
      }
    }
    .grow {
      .growSelect {
        .item {
          width: 490px;
          height: 270px;
        }
        img {
          margin-bottom: 32px;
          max-width: 96px;
        }
      }
      .item:first-child {
        margin-right: 60px;
      }
    }
  } //一行3个
  @media screen and (max-width: 1199px) and (min-width: 960px) {
    padding-top: 130px;
    .titleDiv {
      height: 100px;
      h2 {
        font-size: 26px;
        span > font {
          font-size: 16px;
        }
      }
      h2:before {
        width: 4px;
        height: 48px;
        margin-right: 10px;
      }
    }

    .tabDiv {
      .tab-slide1 {
        height: 125px;
        a {
          padding: 0 20px;
          font-size: 26px;
          line-height: 54px;
          width: 220px;
        }
      }
    } //行业研究
    .yjdiv {
      .item {
        width: 31.7%;
        margin-right: 2.45%;
        margin-bottom: 30px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        a > img {
          height: 258px;
          width: auto;
          max-width: none;
        }
        h4 {
          padding: 18px 10px 5px 10px;
          font-size: 18px;
        }
        p {
          font-size: 14px;
          padding: 0 10px 18px 10px;
        }
        .bottom {
          width: calc(100% - 18px);
          height: 45px;
          margin: 0 9px;
          .timeImg {
            width: 14px;
            height: 14px;
            margin-right: 10px;
          }
          font {
            font-size: 12px;
          }
          .btn {
            font-size: 16px;
            padding: 1px 6px;
          }
        }
      }
      .list {
        width: 100%;
        margin-bottom: 30px;
      }
    } // 行业学习间
    .studyDiv {
      .ppt-ul {
        .item {
          width: 31.7%;
          margin-right: 2.45%;
          margin-bottom: 30px;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .s1-img {
            height: auto;
            width: 100%;
            max-width: none;
          }
          h4 {
            width: 100%;
            padding: 18px 10px 5px 10px;
            font-size: 18px;
          }
        }
      }
      .ebook-ul {
        .item {
          width: 44.8%;
          padding: 0 0 30px 0;
          margin-bottom: 30px;
          img {
            width: 100px;
            height: 100px;
            margin-right: 25px;
          }
          h4 {
            font-size: 18px;
            margin-bottom: 18px;
          }
          span {
            font-size: 16px;
          }
          span.down-btn:before {
            width: 21px;
            height: 21px;
            margin-right: 5px;
          }
        }
      }

      .report-ul {
        .item {
          width: 31.7%;
          margin-right: 2.45%;
          margin-bottom: 30px;
          &:nth-child(3n) {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: auto;
          }
          h4 {
            padding: 18px 10px 5px 10px;
            font-size: 18px;
          }
          p {
            font-size: 14px;
            padding: 0 10px 18px 10px;
          }
          .bottom {
            width: calc(100% - 20px);
            height: 45px;
            font {
              font-size: 12px;
            }
            font:before {
              width: 14px;
              height: 14px;
              margin-right: 10px;
            }
            .btn {
              font-size: 16px;
              padding: 0 6px;
            }
          }
        }
      }
    }

    .btnLine {
      .more-a {
        width: 150px;
        height: 42px;
        border-radius: 26px;
        font-size: 16px;
        margin-bottom: 60px;
      }
    }
    .grow {
      .growSelect {
        .item {
          width: 490px;
          height: 270px;
        }
        img {
          margin-bottom: 32px;
          max-width: 96px;
        }
      }
      .item:first-child {
        margin-right: 60px;
      }
    }
  } //一行两个
  @media screen and (max-width: 959px) and (min-width: 842px) {
    padding-top: 3.52rem;
    .titleDiv {
      height: 3.92rem;
      margin-top: 0.72rem;
      h2 {
        font-size: 1.04rem;
        span > font {
          font-size: 0.96rem;
        }
      }
      h2:before {
        width: 0.1584rem;
        height: 1.92rem;
        margin-right: 0.4rem;
      }
    } //行业研究
    .yjdiv {
      .item {
        width: 48%;
        margin-bottom: 1.2rem;
        margin-right: 2%;
        a > img {
          width: 100%;
          height: auto;
        }
        h4 {
          padding: 0.96rem 0.4rem 0.48rem 0.4rem;
          font-size: 0.96rem;
        }
        p {
          font-size: 0.96rem;
          width: 100%;
          padding: 0 0.4rem 0.96rem 0.4rem;
        }
        .bottom {
          width: calc(100% - 0.8rem);
          height: 2.08rem;
          margin: 0 0.4rem;
          .timeImg {
            width: 0.8rem;
            height: 0.8rem;
            margin-right: 0.6rem;
          }
          font {
            font-size: 0.96rem;
          }
          .btn {
            font-size: 0.96rem;
            padding: 1px 0.48rem;
          }
        }
      }
      .item:nth-child(2n) {
        margin-right: 0px !important;
      }
      .list {
        margin-bottom: 1.2rem;
      }
    } // 行业学习间
    .studyDiv {
      .tab-slide2 a[data-v-594abc0a] {
        font-size: 0.96rem;
        padding-bottom: 0.8rem;
        margin-right: 2.8rem; // position: relative;
      }
      .tab-slide2 a.onthis:after {
        width: 1.44rem;
        height: 0.15872rem;
      }
      .ppt-ul {
        .item {
          width: 48% !important;
          margin-right: 2%;
          margin-bottom: 1.2rem;

          &:nth-child(2n){
            margin-right: 0;
          }

          &:nth-child(3n){
            margin-right: 2%;
          }

          .s1-img {
            width: 100% !important;
            height: auto;
          }
          h4 {
            width: 100%;
            padding: 1.44rem 0.8rem 0.4rem 0.8rem;
            font-size: 0.96rem;
          }
        }
      }
      .ebook-ul {
        .item {
          width: 100%;
          padding: 0 0 1.2rem 0;
          margin-bottom: 1.2rem;
          img {
            width: 8rem;
            height: 8rem;
            margin-right: 1rem;
          }
          h4 {
            font-size: 0.96rem;
            margin-bottom: 1.2rem;
          }
          span {
            font-size: 16px;
          }
          span.down-btn:before {
            width: 0.96rem;
            height: 0.96rem;
            margin-right: 0.4rem;
          }
        }
      }

      .report-ul {
        .item {
          width: 48% !important;
          margin-right: 2%;
          margin-bottom: 1.2rem;
          overflow: hidden;
          &:nth-child(2n){
            margin-right: 0;
          }

          &:nth-child(3n){
            margin-right: 2%;
          }
          img {
            width: 100%;
            height: auto;
          }
          h4 {
            padding: 0.96rem 0.4rem 0.48rem 10px;
            font-size: 0.96rem;
          }
          p {
            font-size: 0.96rem;
            padding: 0 0.4rem 0.96rem 0.4rem;
          }
          .bottom {
            width: calc(100% - 0.8rem);
            height: 2.08rem;
            font {
              font-size: 0.96rem;
            }
            font:before {
              width: 0.8rem;
              height: 0.8rem;
              margin-right: 0.6rem;
            }
            .btn {
              font-size: 0.96rem;
              padding: 0.08rem 0.48rem;
            }
          }
        }
      }
    }
    .btnLine {
      .more-a {
        width: 7.04rem;
        height: 1.76rem;
        border-radius: 26px;
        font-size: 0.96rem;
        margin-bottom: 2rem;
      }
    }
    .grow {
      h3 {
        font-size: 1.12rem;
        padding-bottom: 0.4rem;
        margin-bottom: 3.2rem;
      }
      h3:after {
        content: "";
        width: 2.08rem;
        height: 0.19rem;
        border-radius: 2.5px;
      }
      .growSelect {
        justify-content: space-between;
        .item {
          width: 49%;
          height: 7.92rem;
          font-size: 1.12rem;
          img {
            margin-bottom: 0.84rem;
            height: 3.2rem;
            width: auto;
          }
        }
      }
    }
    .tabDiv {
      .tab-slide {
        width: 100%;
        height: 5rem;
      }
      .tab-slide1 a {
        width: 50%;
        height: 2.08rem;
        padding: 0 0.8rem;
        font-size: 1.04rem;
      }
    }
  }

  @media screen and (max-width: 841px) and (min-width: 320px) {
    padding-top: 3.52rem;
    .titleDiv {
      height: 3.92rem;
      margin-top: 0.72rem;
      h2 {
        font-size: 1.04rem;
        span > font {
          font-size: 0.96rem;
        }
      }
      h2:before {
        width: 0.1584rem;
        height: 1.92rem;
        margin-right: 0.4rem;
      }
    } //行业研究
    .yjdiv {
      .item {
        width: 48% !important;
        margin-bottom: 1.2rem;
        margin-right: 2%;
        a > img {
          width: 100% !important;
          height: auto !important;
        }
        h4 {
          padding: 0.96rem 0.4rem 0.48rem 0.4rem;
          font-size: 0.96rem;
        }
        p {
          font-size: 0.96rem;
          width: 100%;
          padding: 0 0.4rem 0.96rem 0.4rem;
        }
        .bottom {
          width: calc(100% - 0.8rem);
          height: 2.08rem;
          margin: 0 0.4rem;

          .timeImg {
            width: 0.8rem;
            height: 0.8rem;
            margin-right: 0.6rem;
          }
          font {
            font-size: 0.96rem;
          }
          .btn {
            font-size: 0.96rem;
            padding: 1px 0.48rem;
          }
        }
      }
      .item:nth-child(2n) {
        margin-right: 0px !important;
      }
      .list {
        margin-bottom: 1.2rem;
      }
    } // 行业学习间
    .studyDiv {
      .tab-slide2{
        a.tab-a{
          font-size: 0.96rem;
        padding-bottom: 0.8rem;
        margin-right: 2.8rem; // position: relative;
        }
       
      }
      .tab-slide2 a.onthis:after {
        width: 1.44rem;
        height: 0.15872rem;
      }
      .ppt-ul {
        .item {
          width: 48% !important;
          margin-right: 2%;
          margin-bottom: 1.2rem;

          &:nth-child(2n){
            margin-right: 0;
          }

          &:nth-child(3n){
            margin-right: 2%;
          }
          .s1-img {
            width: 100%;
            height: auto;
          }
          h4 {
            width: 100%;
            padding: 1.44rem 0.8rem 0.4rem 0.8rem;
            font-size: 0.96rem;
          }
        }
      }
      .ebook-ul {
        .item {
          width: 100%;
          padding: 0 0 1.2rem 0;
          margin-bottom: 1.2rem;
          img {
            width: 8rem;
            height: 8rem;
            margin-right: 1rem;
          }
          h4 {
            font-size: 0.96rem;
            margin-bottom: 1.2rem;
          }
          span {
            font-size: 16px;
          }
          span.down-btn:before {
            width: 0.96rem;
            height: 0.96rem;
            margin-right: 0.4rem;
          }
        }
      }
      .report-ul {
        .item {
          width: 48% !important;
          margin-right: 2%;
          margin-bottom: 1.2rem;
          overflow: hidden;
          &:nth-child(2n){
            margin-right: 0;
          }

          &:nth-child(3n){
            margin-right: 2%;
          }
          img {
            width: 100%;
            height: auto;
          }
          h4 {
            padding: 0.96rem 0.4rem 0.48rem 10px;
            font-size: 0.96rem;
          }
          p {
            font-size: 0.96rem;
            padding: 0 0.4rem 0.96rem 0.4rem;
          }
          .bottom {
            width:100%;
            padding: 0 .4rem;
            height: 2.08rem;
            font {
              font-size: 0.96rem;
            }
            font:before {
              width: 0.8rem;
              height: 0.8rem;
              margin-right: 0.6rem;
            }
            .btn {
              font-size: 0.96rem;
              padding: 0.08rem 0.48rem;
            }
          }
        }
      }
    }
    .btnLine {
      .more-a {
        width: 7.04rem;
        height: 1.76rem;
        border-radius: 26px;
        font-size: 0.96rem;
        margin-bottom: 2rem;
      }
    }
    .grow {
      h3 {
        font-size: 1.12rem;
        padding-bottom: 0.4rem;
        margin-bottom: 3.2rem;
      }
      h3:after {
        content: "";
        width: 2.08rem;
        height: 0.19rem;
        border-radius: 2.5px;
      }
      .growSelect {
        justify-content: space-between;
        .item {
          width: 49%;
          height: 7.92rem;
          font-size: 1.12rem;
          img {
            margin-bottom: 0.84rem;
            height: 3.2rem;
            width: auto;
          }
        }
      }
    }
    .tabDiv {
      .tab-slide {
        width: 100%;
        height: 5rem;
      }
      .tab-slide1 a {
        width: 50%;
        height: 2.08rem;
        padding: 0 0.8rem;
        font-size: 1.04rem;
      }
    }
  }
} // 查看更多
.btnLine {
  width: 100%;
  margin-top: 30px;
  .more-a {
    border: 1px solid #d2d2d2;
    color: #969696;
  }
  a:hover {
    text-decoration: none;
    color: #333;
  }
}

.grow {
  width: 100%;

  height: auto;
  padding: 50px 0 100px 0;
  background: url(../../assets/images/research-bg.jpg) center center no-repeat;
  background-size: cover;
  color: #fff;
  h3 {
    position: relative;
    font-size: 28px;
    padding-bottom: 10px;
    margin-bottom: 80px;
  }
  h3:after {
    content: "";
    width: 52px;
    height: 5px;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    border-radius: 2.5px;
  }
  .growSelect {
    width: 100%;
    .item {
      background: rgba(0, 0, 0, 0.49);
      a {
        width: 100%;
        height: 100%;
        color: white;
        font-size: 16px;
      }
      .line {
        display: block;
        width: 83.26%;
        height: 1px;
        background: rgba(255, 255, 255, 0.5);
        margin-top: 16px;
        position: relative;
      }
      .line:after {
        content: "";
        display: block;
        width: 72px;
        height: 4px;
        border-radius: 2px;
        background: #007edd;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
      }
    }
    .item:hover {
      box-shadow: 0 0 20px rgba(255, 255, 255, 0.66);
      border: 1px solid white;
    }
  }
}
</style>